<template>
  <div>
    <router-link v-if="to" :to="to" class="fancy-button bg-gradient1">
      <span>
        <v-icon color="white" v-if="icon">{{ icon }}</v-icon>
        <slot></slot>
      </span>
    </router-link>
    <button v-else @click="onClick" class="fancy-button bg-gradient1">
      <span>
        <v-icon color="white" v-if="icon">{{ icon }}</v-icon>
        <slot></slot>
      </span>
    </button>
  </div>
</template>

<script>
export default {
  props: ["icon", "to", "onClick"]
};
</script>

<style scoped>
/* bg shortcodes */
.bg-gradient1 span,
.bg-gradient1:before {
  background: #52a0fd;
  background: -moz-linear-gradient(left, #52a0fd 0%, #00e2fa 80%, #00e2fa 100%);
  background: -webkit-linear-gradient(
    left,
    #52a0fd 0%,
    #00e2fa 80%,
    #00e2fa 100%
  );
  background: linear-gradient(to right, #52a0fd 0%, #00e2fa 80%, #00e2fa 100%);
}

/* General */
a {
  text-decoration: none;
}
a:hover,
a:focus,
a:active {
  text-decoration: none;
}
/* fancy Button */
.fancy-button {
  display: inline-block;
  font-family: "Montserrat", Helvetica, Arial, sans-serif;
  letter-spacing: 0.03em;
  color: #fff;
}
.fancy-button:before {
  content: "";
  display: inline-block;
  height: 40px;
  position: absolute;
  bottom: -5px;
  left: 30px;
  right: 30px;
  z-index: -1;
  border-radius: 30em;
  filter: blur(20px) brightness(0.95);
  transform-style: preserve-3d;
  transition: all 0.3s ease-out;
}
.fancy-button i {
  margin-top: -1px;
  margin-right: 20px;
  font-size: 1.265em;
  vertical-align: middle;
}
.fancy-button span {
  display: inline-block;
  padding: 4px 20px;
  border-radius: 50em;
  position: relative;
  z-index: 2;
  will-change: transform, filter;
  transform-style: preserve-3d;
  transition: all 0.3s ease-out;
}
.fancy-button:focus,
.fancy-button:active {
  color: #fff;
}
.fancy-button:hover {
  color: #fff;
}
.fancy-button:hover span {
  filter: brightness(1.05) contrast(1.05);
  transform: scale(0.95);
}
.fancy-button:hover:before {
  bottom: 0;
  filter: blur(10px) brightness(0.95);
}
.fancy-button.pop-onhover:before {
  opacity: 0;
  bottom: 10px;
}
.fancy-button.pop-onhover:hover:before {
  bottom: -7px;
  opacity: 1;
  filter: blur(20px);
}
.fancy-button.pop-onhover:hover span {
  transform: scale(1.04);
}
.fancy-button.pop-onhover:hover:active span {
  filter: brightness(1) contrast(1);
  transform: scale(1);
  transition: all 0.15s ease-out;
}
.fancy-button.pop-onhover:hover:active:before {
  bottom: 0;
  filter: blur(10px) brightness(0.95);
  transition: all 0.2s ease-out;
}
</style>